const initialStateInfoFiscal = {
  id: "",
  ref: "",
  descricao: "",
  idCategoriaRef: null,
  flags: {
    isManual: false, enableCreditoPresumido: false, enableIssqn: false
  },
  refObject: {
    icms: [
      {
        tipo_tributacao: "simples_nacional",
        cenario: "saida_dentro_estado",
        tipo_pessoa: "fisica",
        nao_contribuinte: false,
        codigo_cfop: "5102",
        situacao_tributaria: "102",
        aliquota_credito: "",
        aliquota_icms: [
          {
            estado: "",
            aliquota: "0.00",
          },
        ],
        aliquota_mva: [
          {
            estado: "",
            aliquota: "0.00",
          },
        ],
        aliquota_fcp: [
          {
            estado: "",
            aliquota: "0.00",
          },
        ],
        aliquota_fcp_st: [
          {
            estado: "",
            aliquota: "0.00",
          },
        ],
        aliquota_diferimento: "0.00",
        aliquota_diferimento_fcp: "0.00",
        aliquota_reducao: "0.00",
        aliquota_reducao_st: "0.00",
        motivo_desoneracao: "9",
        motivo_desoneracao_st: "9",
        deducao_desoneracao: 0,
        beneficio_fiscal: [
          {
            estado: "",
            codigo: "",
          },
        ],
      },
    ],
    ipi: [
      {
        cenario: "padrao",
        tipo_pessoa: "fisica",
        situacao_tributaria: "99",
        codigo_enquadramento: "999",
        aliquota: "0.00",
        ipi_devolvido: "0.00",
      },
    ],
    pis: [
      {
        cenario: "padrao",
        tipo_pessoa: "fisica",
        situacao_tributaria: "99",
        aliquota: "0.00",
      },
    ],
    cofins: [
      {
        cenario: "padrao",
        tipo_pessoa: "fisica",
        situacao_tributaria: "99",
        aliquota: "0.00",
      },
    ],
    issqn: [
      {
        cenario: "",
        tipo_pessoa: "",
        codigo_cfop: "",
        exigibilidade: "",
        item_servico: "",
        incentivo_fiscal: "",
        aliquota: "",
      },
    ],
    ibs_cbs: [
      {
        tipo_pessoa: "padrao",
        cenario: "padrao",
        situacao_tributaria: "000",
        situacao_tributaria_regular: '000',
        classificacao_tributaria: "000001",
        classificacao_tributaria_regular: "000001",
        ibs_estadual: {
          aliquota_diferimento: 0,
        },
        ibs_municipal: {
          aliquota_diferimento: 0,
        },
        cbs: {
          aliquota_diferimento: 0,
        },
        credito_presumido: {
          classificacao: "3",
          aliquota_ibs: 0,
          aliquota_cbs: 0,
        }
      },
    ],
    informacoes_fisco: "",
    informacoes_complementares: "",
  },
  imposto_manual: {
    ipi: {
      "situacao_tributaria": 99, //OBRIGATORIO SEMPRE
      "codigo_enquadramento": 999, //OBRIGATORIO SEMPRE
      "aliquota": 0.00, //OBRIGATORIO SEMPRE
      "percentual_devolvido": null,
      "ipi_devolvido": null,
      "codigo_selo": null,
      "qtd_selo": null,
      "bc_ipi": null,
    },
    pis: {
      "situacao_tributaria": 99, //OBRIGATORIO SEMPRE
      "aliquota": 0.00, //OBRIGATORIO SEMPRE
      "majoracao": null,
      "bc_pis": null,
    },
    cofins: {
      "situacao_tributaria": 99, //OBRIGATORIO SEMPRE
      "aliquota": 0.00, //OBRIGATORIO SEMPRE
      "majoracao": null,
      "bc_cofins": null,
    },
    issqn: {
      "codigo_cfop": null, //OBRIGATORIO SEMPRE
      "exigibilidade": null, //OBRIGATORIO SEMPRE
      "item_servico": null, //OBRIGATORIO SEMPRE
      "incentivo_fiscal": 2, //OBRIGATORIO SEMPRE
      "aliquota": 0.00, //OBRIGATORIO SEMPRE
      "deducao": null,
      "retencoes": null,
      "desconto_incondicionado": null,
      "desconto_condicionado": null,
      "iss_retido": null,
      "municipio": null,
      "codigo_servico": null,
      "processo": null,
    },
    icms: {
      "aliquota": 0.00,
      "aliquota_fcp": 0.00,
      "aliquota_interestadual": 0.00,
      "codigo_cfop": 5102, //OBRIGATORIO SEMPRE
      "situacao_tributaria": 102, //OBRIGATORIO SEMPRE
      "aliquota_importacao": 0.00,
      "industria": 0,
      "majoracao": 0.00,
      "bc_icms": 0.00,
      "bc_icms_st": 0.00,
      "aliquota_diferimento": 0.00,
      "aliquota_diferimento_fcp": 0.00,
      "difal_antecipacao": false,
      "credito_presumido": {
        "codigo_beneficio_fiscal": null,
        "aliquota": 0.00,
        "valor": 0.00,
      },
      "aliquota_credito": 0.00, //OBRIGATORIO SEMPRE 101
      "aliquota_st": 0.00, // 201
      "aliquota_fcp_st": 0.00, // 201
      "aliquota_mva": 0.00, //OBRIGATORIO SEMPRE 201
      "aliquota_reducao": 0.00, // 201
      "aliquota_reducao_st": 0.00, // 201
      "bc_st_retido": 0.00,
      "aliquota_st_retido": 0.00,
      "valor_st_retido": 0.00,
      "valor_icms_substituto": 0.00,
      "valor_fcp_retido": 0.00,
      "aliquota_fcp_retido": 0.00,
      "aliquota_bc_efetivo": 0.00,
      "aliquota_icms_efetivo": 0.00,
      "pauta_fiscal": 0, //OBRIGATORIO SEMPRE
      "quantidade_bc": 0, //OBRIGATORIO SEMPRE
      "motivo_desoneracao_st": null,
      "quantidade_retencao": 0, //OBRIGATORIO SEMPRE
      "aliquota_retencao": 0.00, //OBRIGATORIO SEMPRE
      "percentual_reducao": 0.00,
      "motivo_reducao": null,
      "deducao_desoneracao": null,
      "bc_st_dest": 0.00,
      "valor_st_dest": 0.00,
      "tipo_tributacao": "simples_nacional",
    },
    "ibs_cbs": {
      "tipo_pessoa": "padrao",
      "cenario": "padrao",
      "situacao_tributaria": "000",
      "situacao_tributaria_regular": '000',
      "classificacao_tributaria": "000001",
      "classificacao_tributaria_regular": "000001",
      "ibs_estadual": {
        "aliquota_diferimento": 0,
      },
      "ibs_municipal": {
        "aliquota_diferimento": 0,
      },
      "cbs": {
        "aliquota_diferimento": 0,
      },
      "credito_presumido": {
        "classificacao": "3",
        "aliquota_ibs": 0,
        "aliquota_cbs": 0,
      }
    },
  },
}

const initialStateTaxForSelectBoxes = {
  icms: {
    tipo_tributacao: [
      { value: "simples_nacional", text: "Simples Nacional" },
      { value: "tributacao_normal", text: "Tributação Normal" },
    ],
    cenario: [
      { value: "saida_dentro_estado", text: "Saída dentro do estado" },
      {
        value: "saida_fora_estado",
        text: "Saída fora do estado",
      },
      {
        value: "entrada_dentro_estado",
        text: "Entrada dentro do estado",
      },
      {
        value: "entrada_fora_estado",
        text: "Entrada fora do estado",
      },
      { value: "saida_exterior", text: "Saída para o Exterior" },
      { value: "entrada_exterior", text: "Entrada do Exterior" },
    ],
    tipo_pessoa: [
      { value: "fisica", text: "Fisica" },
      { value: "juridica", text: "Juridica" },
      { value: "estrangeira", text: "Estrangeira" },
    ],
    situacao_tributaria: [
      { value: "101", text: "101 - Tributada com permissão de crédito" },
      { value: "102", text: "102 - Tributada sem permissão de crédito" },
      {
        value: "103",
        text: "103 - Isenção do ICMS para faixa de receita bruta",
      },
      {
        value: "201",
        text: "201 - Tributada com permissão de crédito e com cobrança do ICMS por substituição tributária",
      },
      {
        value: "202",
        text: "202 - Tributada sem permissão de crédito e com cobrança do ICMS por substituição tributária",
      },
      {
        value: "203",
        text: "203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por substituição tributária",
      },
      { value: "300", text: "300 - Imune" },
      { value: "400", text: "400 - Não tributada" },
      {
        value: "500",
        text: "500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação",
      },
      { value: "900", text: "900 - Outros" },
      { value: "00", text: "00 - Tributada integralmente" },
      {
        value: "10",
        text: "10 - Tributada e com cobrança do ICMS por substituição tributária",
      },
      { value: "20", text: "20 - Com redução da base de cálculo" },
      {
        value: "30",
        text: "30 - Isenta ou não tributada e com cobrança do ICMS por substituição tributária",
      },
      { value: "40", text: "40 - Isenta" },
      { value: "41", text: "41 - Não tributada" },
      { value: "50", text: "50 - Suspensão" },
      { value: "51", text: "51 - Diferimento" },
      {
        value: "60",
        text: "60 - ICMS cobrado anteriormente por substituição tributária",
      },
      {
        value: "70",
        text: "70 - Com redução de base de cálculo e cobrança do ICMS por substituição tributária",
      },
      { value: "90", text: "90 - Outros" },
    ],
    motivo_desoneracao: [
      { value: null, text: "--" },
      { value: "3", text: "3 - Uso na agropecuária" },
      { value: "9", text: "9 - Outros" },
      {
        value: "12",
        text: "12 - Órgão de fomento e desenvolvimento agropecuário",
      },
    ],
    motivo_desoneracao_st: [
      { value: null, text: "--" },
      { value: "3", text: "3 - Uso na agropecuária" },
      { value: "9", text: "9 - Outros" },
      {
        value: "12",
        text: "12 - Órgão de fomento e desenvolvimento agropecuário",
      },
    ],
    estados: [
      { value: "AC", text: "AC" },
      { value: "AL", text: "AL" },
      { value: "AP", text: "AP" },
      { value: "AM", text: "AM" },
      { value: "BA", text: "BA" },
      { value: "CE", text: "CE" },
      { value: "ES", text: "ES" },
      { value: "GO", text: "GO" },
      { value: "MA", text: "MA" },
      { value: "MT", text: "MT" },
      { value: "MS", text: "MS" },
      { value: "MG", text: "MG" },
      { value: "PA", text: "PA" },
      { value: "PB", text: "PB" },
      { value: "PR", text: "PR" },
      { value: "PE", text: "PE" },
      { value: "PI", text: "PI" },
      { value: "RJ", text: "RJ" },
      { value: "RN", text: "RN" },
      { value: "RS", text: "RS" },
      { value: "RO", text: "RO" },
      { value: "RR", text: "RR" },
      { value: "SC", text: "SC" },
      { value: "SP", text: "SP" },
      { value: "SE", text: "SE" },
      { value: "TO", text: "TO" },
      { value: "DF", text: "DF" },
    ],
    beneficioFiscalEstados: [
      { value: "DF", text: "DF" },
      { value: "PR", text: "PR" },
      { value: "RS", text: "RS" },
      { value: "RJ", text: "RJ" },
    ],
  },
  ipi: {
    cenario: [
      { value: "padrao", text: "Padrão (Abrange todos os cenários)" },
      {
        value: "saida_dentro_estado",
        text: "Saída dentro do estado",
      },
      {
        value: "saida_fora_estado",
        text: "Saída fora do estado",
      },
      {
        value: "entrada_dentro_estado",
        text: "Entrada dentro do estado",
      },
      {
        value: "entrada_fora_estado",
        text: "Entrada fora do estado",
      },
      { value: "saida_exterior", text: "Saída para o Exterior" },
      { value: "entrada_exterior", text: "Entrada do Exterior" },
    ],
    tipo_pessoa: [
      { value: "fisica", text: "Fisica" },
      { value: "juridica", text: "Juridica" },
      { value: "estrangeira", text: "Estrangeira" },
    ],
    situacao_tributaria: [
      { value: "00", text: "00 - Entrada com recuperação de crédito" },
      { value: "01", text: "01 - Entrada tributada com alíquota zero" },
      { value: "02", text: "02 - Entrada isenta" },
      { value: "03", text: "03 - Entrada não-tributada" },
      { value: "04", text: "04 - Entrada imune" },
      { value: "05", text: "05 - Entrada com suspensão" },
      { value: "49", text: "49 - Outras entradas" },
      { value: "50", text: "50 - Saída tributada" },
      { value: "51", text: "51 - Saída tributada com alíquota zero" },
      { value: "52", text: "52 - Saída isenta" },
      { value: "53", text: "53 - Saída não-tributada" },
      { value: "54", text: "54 - Saída imune" },
      { value: "55", text: "55 - Saída com suspensão" },
      { value: "99", text: "99 - Outras saídas" },
    ],
  },
  pis: {
    cenario: [
      { value: "padrao", text: "Padrão (Abrange todos os cenários)" },
      {
        value: "saida_dentro_estado",
        text: "Saída dentro do estado",
      },
      {
        value: "saida_fora_estado",
        text: "Saída fora do estado",
      },
      {
        value: "entrada_dentro_estado",
        text: "Entrada dentro do estado",
      },
      {
        value: "entrada_fora_estado",
        text: "Entrada fora do estado",
      },
      { value: "saida_exterior", text: "Saída para o Exterior" },
      { value: "entrada_exterior", text: "Entrada do Exterior" },
    ],
    tipo_pessoa: [
      { value: "fisica", text: "Fisica" },
      { value: "juridica", text: "Juridica" },
      { value: "estrangeira", text: "Estrangeira" },
    ],
    situacao_tributaria: [
      {
        value: "01",
        text: "01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não cumulativo)",
      },
      {
        value: "02",
        text: "02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota diferenciada)",
      },
      {
        value: "03",
        text: "03 - Operação Tributável - Base de Cálculo = Quantidade Vendida X Alíquota por Unidade de Produto",
      },
      {
        value: "04",
        text: "04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)",
      },
      {
        value: "05",
        text: "05 - Operação Tributável - (Substituição Tributária)",
      },
      {
        value: "06",
        text: "06 - Operação Tributável (Alíquota Zero)",
      },
      {
        value: "07",
        text: "07 - Operação Isenta de Contribuição",
      },
      {
        value: "08",
        text: "08 - Operação sem Incidência da Contribuição",
      },
      {
        value: "09",
        text: "09 - Operação com Suspensão da Contribuição",
      },
      {
        value: "49",
        text: "49 - Outras Operações de Saída",
      },
      {
        value: "50",
        text: "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      },
      {
        value: "51",
        text: "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno",
      },
      {
        value: "52",
        text: "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação",
      },
      {
        value: "53",
        text: "53 - Operação com Direito a Crédito - Vinculado a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      },
      {
        value: "54",
        text: "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "55",
        text: "55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "56",
        text: "56 - Operação com Direito a Crédito - Vinculado a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      },
      {
        value: "60",
        text: "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      },
      {
        value: "61",
        text: "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
      },
      {
        value: "62",
        text: "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação",
      },
      {
        value: "63",
        text: "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      },
      {
        value: "64",
        text: "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "65",
        text: "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "66",
        text: "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      },
      {
        value: "67",
        text: "67 - Crédito Presumido - Outras Operações",
      },
      {
        value: "70",
        text: "70 - Operação de Aquisição sem Direito a Crédito",
      },
      {
        value: "71",
        text: "71 - Operação de Aquisição com Isenção",
      },
      {
        value: "72",
        text: "72 - Operação de Aquisição com Suspensão",
      },
      {
        value: "73",
        text: "73 - Operação de Aquisição a Alíquota Zero",
      },
      {
        value: "74",
        text: "74 - Operação de Aquisição sem Incidência da Contribuição",
      },
      {
        value: "75",
        text: "75 - Operação de Aquisição por Substituição Tributária",
      },
      {
        value: "98",
        text: "98 - Outras Operações de Entrada",
      },
      {
        value: "99",
        text: "99 - Outras Operações",
      },
    ],
  },
  cofins: {
    cenario: [
      { value: "padrao", text: "Padrão (Abrange todos os cenários)" },
      {
        value: "saida_dentro_estado",
        text: "Saída dentro do estado",
      },
      {
        value: "saida_fora_estado",
        text: "Saída fora do estado",
      },
      {
        value: "entrada_dentro_estado",
        text: "Entrada dentro do estado",
      },
      {
        value: "entrada_fora_estado",
        text: "Entrada fora do estado",
      },
      { value: "saida_exterior", text: "Saída para o Exterior" },
      { value: "entrada_exterior", text: "Entrada do Exterior" },
    ],
    tipo_pessoa: [
      { value: "fisica", text: "Fisica" },
      { value: "juridica", text: "Juridica" },
      { value: "estrangeira", text: "Estrangeira" },
    ],
    situacao_tributaria: [
      {
        value: "01",
        text: "01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não cumulativo)",
      },
      {
        value: "02",
        text: "02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota diferenciada)",
      },
      {
        value: "03",
        text: "03 - Operação Tributável - Base de Cálculo = Quantidade Vendida X Alíquota por Unidade de Produto",
      },
      {
        value: "04",
        text: "04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)",
      },
      {
        value: "05",
        text: "05 - Operação Tributável - (Substituição Tributária)",
      },
      {
        value: "06",
        text: "06 - Operação Tributável (Alíquota Zero)",
      },
      {
        value: "07",
        text: "07 - Operação Isenta de Contribuição",
      },
      {
        value: "08",
        text: "08 - Operação sem Incidência da Contribuição",
      },
      {
        value: "09",
        text: "09 - Operação com Suspensão da Contribuição",
      },
      {
        value: "49",
        text: "49 - Outras Operações de Saída",
      },
      {
        value: "50",
        text: "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      },
      {
        value: "51",
        text: "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não Tributada no Mercado Interno",
      },
      {
        value: "52",
        text: "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação",
      },
      {
        value: "53",
        text: "53 - Operação com Direito a Crédito - Vinculado a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      },
      {
        value: "54",
        text: "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "55",
        text: "55 - Operação com Direito a Crédito - Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "56",
        text: "56 - Operação com Direito a Crédito - Vinculado a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      },
      {
        value: "60",
        text: "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno",
      },
      {
        value: "61",
        text: "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno",
      },
      {
        value: "62",
        text: "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação",
      },
      {
        value: "63",
        text: "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno",
      },
      {
        value: "64",
        text: "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "65",
        text: "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação",
      },
      {
        value: "66",
        text: "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno, e de Exportação",
      },
      {
        value: "67",
        text: "67 - Crédito Presumido - Outras Operações",
      },
      {
        value: "70",
        text: "70 - Operação de Aquisição sem Direito a Crédito",
      },
      {
        value: "71",
        text: "71 - Operação de Aquisição com Isenção",
      },
      {
        value: "72",
        text: "72 - Operação de Aquisição com Suspensão",
      },
      {
        value: "73",
        text: "73 - Operação de Aquisição a Alíquota Zero",
      },
      {
        value: "74",
        text: "74 - Operação de Aquisição sem Incidência da Contribuição",
      },
      {
        value: "75",
        text: "75 - Operação de Aquisição por Substituição Tributária",
      },
      {
        value: "98",
        text: "98 - Outras Operações de Entrada",
      },
      {
        value: "99",
        text: "99 - Outras Operações",
      },
    ],
  },
  issqn: {
    cenario: [
      { value: "padrao", text: "Padrão (Abrange todos os cenários)" },
      {
        value: "saida_dentro_estado",
        text: "Saída dentro do estado",
      },
      {
        value: "saida_fora_estado",
        text: "Saída fora do estado",
      },
      {
        value: "entrada_dentro_estado",
        text: "Entrada dentro do estado",
      },
      {
        value: "entrada_fora_estado",
        text: "Entrada fora do estado",
      },
      { value: "saida_exterior", text: "Saída para o Exterior" },
      { value: "entrada_exterior", text: "Entrada do Exterior" },
    ],
    tipo_pessoa: [
      { value: "fisica", text: "Fisica" },
      { value: "juridica", text: "Juridica" },
      { value: "estrangeira", text: "Estrangeira" },
    ],
    exigibilidade: [
      { value: "1", text: "Exigível" },
      { value: "2", text: "Não incidência" },
      { value: "3", text: "Isenção" },
      { value: "4", text: "Exportação" },
      { value: "5", text: "Imunidade" },
      { value: "6", text: "Exigibilidade Suspensa por Decisão Judicial" },
      {
        value: "7",
        text: "Exigibilidade Suspensa por Processo Administrativo",
      },
    ],
    incentivo_fiscal: [
      { value: "1", text: "Sim" },
      { value: "2", text: "Não" },
    ],
  },
  ibs_cbs: {
    cenario: [
      { value: "padrao", text: "Padrão" },
      { value: "saida_dentro_estado", text: "Saída dentro do estado" },
      {
        value: "saida_fora_estado",
        text: "Saída fora do estado",
      },
      {
        value: "entrada_dentro_estado",
        text: "Entrada dentro do estado",
      },
      {
        value: "entrada_fora_estado",
        text: "Entrada fora do estado",
      },
      { value: "saida_exterior", text: "Saída para o Exterior" },
      { value: "entrada_exterior", text: "Entrada do Exterior" },
    ],
    tipo_pessoa: [
      { value: "padrao", text: "Padrão" },
      { value: "fisica", text: "Fisica" },
      { value: "juridica", text: "Juridica" },
      { value: "estrangeira", text: "Estrangeira" },
    ],
    situacao_tributaria: [
      { value: "000", text: "000 - Tributação integral" },
      { value: "200", text: "200 - Alíquota reduzida" },
      {
        value: "410",
        text: "410 - Imunidade e não incidência",
      },
      {
        value: "510",
        text: "510 - Diferimento",
      },
      {
        value: "550",
        text: "550 - Suspensão",
      },
      {
        value: "620",
        text: "620 - Tributação monofásica",
      },
      { value: "800", text: "800 - Transferência de crédito" },
    ],
    credito_presumido: [
      { value: "3", text: "3 - Aquisição de materiais para reciclagem" },
      { value: "4", text: "4 - Bens móveis usados para revenda" },
      { value: "5", text: "5 - Regime automotivo - Art. 310" },
      { value: "6", text: "6 - Regime automotivo - Art. 311" },
      { value: "7", text: "7 - Zona Franca de Manaus - Art. 444" },
      { value: "10", text: "10 - Zona Franca de Manaus - Art. 450" },
      { value: "11", text: "11 - Área de Livre Comércio - Art. 462" },
      { value: "13", text: "13 - Área de Livre Comércio (Indústria) - Art. 467" },
    ],
    sit000: [
      { value: "000001", text: "000001 - Situações tributadas integralmente pelo IBS e CBS." },
      { value: "000002", text: "000002 - Exploração de via" },
      { value: "000003", text: "000003 - Regime automotivo - projetos incentivados (art. 311)" },
      { value: "000004", text: "000004 - Regime automotivo - projetos incentivados (art. 312)" },
    ],
    sit200: [
      { value: "200001", text: "200001 - Aquisições realizadas entre empresas autorizadas a operar em zonas de processamento de exportação" },
      { value: "200002", text: "200002 - Fornecimento ou importação para produtor rural não contribuinte ou TAC" },
      { value: "200003", text: "200003 - Vendas de produtos destinados à alimentação humana (Anexo I)" },
      { value: "200004", text: "200004 - Venda de dispositivos médicos (Anexo XII)" },
      { value: "200005", text: "200005 - Venda de dispositivos médicos adquiridos por órgãos da administração pública (Anexo IV)" },
      { value: "200006", text: "200006 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XII)" },
      { value: "200007", text: "200007 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo XIII)" },
      { value: "200008", text: "200008 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência adquiridos por órgãos da administração pública (Anexo V)" },
      { value: "200009", text: "200009 - Fornecimento de medicamentos (Anexo XIV)" },
      { value: "200010", text: "200010 - Fornecimento dos medicamentos registrados na Anvisa" },
      { value: "200011", text: "200011 - Fornecimento das composições para nutrição enteral e parenteral quando adquiridas por órgãos da administração pública (Anexo VI)" },
      { value: "200012", text: "200012 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XIV)" },
      { value: "200013", text: "200013 - Fornecimento de tampões higiênicos" },
      { value: "200014", text: "200014 - Fornecimento dos produtos hortícolas" },
      { value: "200015", text: "200015 - Venda de automóveis de passageiros de fabricação nacional adquiridos por motoristas profissionais ou pessoas com deficiência" },
      { value: "200016", text: "200016 - Prestação de serviços de pesquisa e desenvolvimento por Instituição Científica" },
      { value: "200017", text: "200017 - Operações relacionadas ao FGTS" },
      { value: "200018", text: "200018 - Operações de resseguro e retrocessão" },
      { value: "200019", text: "200019 - Importador dos serviços financeiros contribuinte" },
      { value: "200020", text: "200020 - Operação praticada por sociedades cooperativas optantes por regime específico do IBS e CBS" },
      { value: "200021", text: "200021 - Serviços de transporte público coletivo de passageiros ferroviário e hidroviário" },
      { value: "200022", text: "200022 - Operação originada fora da ZFM que destine bem material industrializado a contribuinte estabelecido na ZFM" },
      { value: "200023", text: "200023 - Operação realizada por indústria incentivada que destine bem material intermediário para outra indústria incentivada na ZFM" },
      { value: "200024", text: "200024 - Operação originada fora das Áreas de Livre Comércio destinadas a contribuinte estabelecido nas Áreas de Livre Comércio" },
      { value: "200025", text: "200025 - Fornecimento dos serviços de educação relacionados ao Programa Universidade para Todos (Prouni)" },
      { value: "200026", text: "200026 - Locação de imóveis localizados nas zonas reabilitadas" },
      { value: "200027", text: "200027 - Operações de locação" },
      { value: "200028", text: "200028 - Fornecimento dos serviços de educação (Anexo II)" },
      { value: "200029", text: "200029 - Fornecimento dos serviços de saúde humana (Anexo III)" },
      { value: "200030", text: "200030 - Venda dos dispositivos médicos (Anexo IV)" },
      { value: "200031", text: "200031 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo V)" },
      { value: "200032", text: "200032 - Fornecimento dos medicamentos registrados na Anvisa ou produzidos por farmácias de manipulação" },
      { value: "200033", text: "200033 - Fornecimento das composições para nutrição enteral e parenteral (Anexo VI)" },
      { value: "200034", text: "200034 - Fornecimento dos alimentos destinados ao consumo humano (Anexo VII)" },
      { value: "200035", text: "200035 - Fornecimento dos produtos de higiene pessoal e limpeza (Anexo VIII)" },
      { value: "200036", text: "200036 - Fornecimento de produtos agropecuários" },
      { value: "200037", text: "200037 - Fornecimento de serviços ambientais de conservação ou recuperação da vegetação nativa" },
      { value: "200038", text: "200038 - Fornecimento dos insumos agropecuários e aquícolas (Anexo IX)" },
      { value: "200039", text: "200039 - Fornecimento dos serviços e o licenciamento ou cessão dos direitos destinados às produções nacionais artísticas (Anexo X)" },
      { value: "200040", text: "200040 - Fornecimento de serviços de comunicação institucional à administração pública" },
      { value: "200041", text: "200041 - Fornecimento de serviço de educação desportiva (art. 141. I)" },
      { value: "200042", text: "200042 - Fornecimento de serviço de educação desportiva (art. 141. II)" },
      { value: "200043", text: "200043 - Fornecimento à administração pública dos serviços e dos bens relativos à soberania (Anexo XI)" },
      { value: "200044", text: "200044 - Operações e prestações de serviços de segurança da informação e segurança cibernética desenvolvidos por sociedade que tenha sócio brasileiro (Anexo XI)" },
      { value: "200045", text: "200045 - Operações relacionadas a projetos de reabilitação urbana de zonas históricas e de áreas críticas de recuperação e reconversão urbanística" },
      { value: "200046", text: "200046 - Operações com bens imóveis" },
      { value: "200047", text: "200047 - Bares e Restaurantes" },
      { value: "200048", text: "200048 - Hotelaria" },
      { value: "200049", text: "200049 - Transporte coletivo de passageiros rodoviário" },
      { value: "200450", text: "200450 - Serviços de transporte aéreo regional coletivo de passageiros ou de carga" },
      { value: "200051", text: "200051 - Agências de Turismo" },
      { value: "200052", text: "200052 - Prestação de serviços de profissões intelectuais" },
    ],
    sit410: [
      { value: "410001", text: "410001 - Fornecimento de bonificações quando constem no documento fiscal e que não dependam de evento posterior" },
      { value: "410002", text: "410002 - Transferências entre estabelecimentos pertencentes ao mesmo contribuinte" },
      { value: "410003", text: "410003 - Doações sem contraprestação em benefício do doador" },
      { value: "410004", text: "410004 - Exportações de bens e serviços" },
      { value: "410005", text: "410005 - Fornecimentos realizados pela União" },
      { value: "410006", text: "410006 - Fornecimentos realizados por entidades religiosas e templos de qualquer culto" },
      { value: "410007", text: "410007 - Fornecimentos realizados por partidos políticos" },
      { value: "410008", text: "410008 - Fornecimentos de livros" },
      { value: "410009", text: "410009 - Fornecimentos de fonogramas e videofonogramas musicais produzidos no Brasil" },
      { value: "410010", text: "410010 - Fornecimentos de serviço de comunicação nas modalidades de radiodifusão sonora e de sons e imagens de recepção livre e gratuita" },
      { value: "410011", text: "410011 - Fornecimentos de ouro" },
      { value: "410012", text: "410012 - Fornecimento de condomínio edilício não optante pelo regime regular" },
      { value: "410013", text: "410013 - Exportações de combustíveis" },
      { value: "410014", text: "410014 - Fornecimento de produtor rural não contribuinte" },
      { value: "410015", text: "410015 - Fornecimento por transportador autônomo não contribuinte" },
      { value: "410016", text: "410016 - Fornecimento ou aquisição de resíduos sólidos" },
      { value: "410017", text: "410017 - Aquisição de bem móvel com crédito presumido sob condição de revenda realizada" },
      { value: "410018", text: "410018 - Operações relacionadas aos fundos garantidores e executores de políticas públicas" },
      { value: "410019", text: "410019 - Exclusão da gorjeta na base de cálculo no fornecimento de alimentação" },
      { value: "410020", text: "410020 - Exclusão do valor de intermediação na base de cálculo no fornecimento de alimentação" },
      { value: "410021", text: "410021 - Contribuição de que trata o art. 149-A da Constituição Federal" },
      { value: "410999", text: "410999 - Operações não onerosas sem previsão de tributação" },
    ],
    sit510: [
      { value: "510001", text: "510001 - Operações, sujeitas a diferimento, com energia elétrica, relativas à geração, comercialização, distribuição e transmissão" },
      { value: "510002", text: "510002 - Operações, sujeitas a diferimento, com insumos agropecuários e aquícolas destinados a produtor rural contribuinte (Anexo IX)" },
    ],
    sit550: [
      { value: "550001", text: "550001 - Exportações de bens materiais" },
      { value: "550002", text: "550002 - Regime de Trânsito" },
      { value: "550003", text: "550003 - Regimes de Depósito (art. 85)" },
      { value: "550004", text: "550004 - Regimes de Depósito (art. 87)" },
      { value: "550005", text: "550005 - Regimes de Depósito (art. 87, Parágrafo Único)" },
      { value: "550006", text: "550006 - Regimes de Permanência Temporária" },
      { value: "550007", text: "550007 - Regimes de Aperfeiçoamento" },
      { value: "550008", text: "550008 - Importação de bens para o Regime de Repetro-Temporário" },
      { value: "550009", text: "550009 - GNL-Temporário" },
      { value: "550010", text: "550010 - Repetro-Permanente" },
      { value: "550011", text: "550011 - Repetro-Industrialização" },
      { value: "550012", text: "550012 - Repetro-Nacional" },
      { value: "550013", text: "550013 - Repetro-Entreposto" },
      { value: "550014", text: "550014 - Zona de Processamento de Exportação" },
      { value: "550015", text: "550015 - Regime Tributário para Incentivo à Modernização e à Ampliação da Estrutura Portuária" },
      { value: "550016", text: "550016 - Regime Especial de Incentivos para o Desenvolvimento da Infraestrutura" },
      { value: "550017", text: "550017 - Regime Tributário para Incentivo à Atividade Econômica Naval" },
      { value: "550018", text: "550018 - Desoneração da aquisição de bens de capital" },
      { value: "550019", text: "550019 - Importação de bem material por indústria incentivada para utilização na ZFM" },
      { value: "550020", text: "550020 - Áreas de livre comércio" },
    ],
    sit620: [
      { value: "620001", text: "620001 - Tributação monofásica sobre combustíveis" },
      { value: "620002", text: "620002 - Tributação monofásica com responsabilidade pela retenção sobre combustíveis" },
      { value: "620003", text: "620003 - Tributação monofásica com tributos retidos por responsabilidade sobre combustíveis" },
      { value: "620004", text: "620004 - Tributação monofásica sobre mistura de EAC com gasolina A em percentual superior ao obrigatório" },
      { value: "620005", text: "620005 - Tributação monofásica sobre mistura de EAC com gasolina A em percentual inferior ao" },
      { value: "620006", text: "620006 - Tributação monofásica sobre combustíveis cobrada anteriormente" },
    ],
    sit800: [
      { value: "800001", text: "800001 - Fusão, cisão ou incorporação" },
      { value: "800002", text: "800002 - Transferência de crédito do associado, inclusive as cooperativas singulares" },

    ],
  },
}

const initialStateObjectIcms = {
  "101": {
    aliquota_credito: true,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    aliquota_fcp_st: false,
    deducao_desoneracao: false,
  },
  "102": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: false,
  },
  "103": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: false,
  },
  "201": {
    aliquota_credito: true,
    aliquota_mva: true,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: true,
    aliquota_reducao_st: true,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: false,
  },
  "202": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: true,
    aliquota_reducao_st: true,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: false,
  },
  "203": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: true,
    aliquota_reducao_st: true,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: false,
  },
  "300": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: false,
  },
  "400": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: false,
  },
  "500": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: false,
  },
  "900": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_icms: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: true,
    aliquota_reducao_st: true,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: false,
  },
  "00": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    deducao_desoneracao: true,
  },
  "10": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: true,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: true,
  },
  "20": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: true,
    aliquota_reducao_st: false,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    deducao_desoneracao: true,
  },
  "30": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: true,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: true,
  },
  "40": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: true,
  },
  "41": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: true,
  },
  "50": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: false,
    deducao_desoneracao: true,
  },
  "51": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: true,
    aliquota_diferimento_fcp: true,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    deducao_desoneracao: true,
  },
  "60": {
    aliquota_credito: false,
    aliquota_mva: false,
    aliquota_icms: false,
    aliquota_diferimento: false,
    aliquota_diferimento_fcp: false,
    aliquota_reducao: false,
    aliquota_reducao_st: false,
    motivo_desoneracao: false,
    motivo_desoneracao_st: false,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    deducao_desoneracao: true,
  },
  "70": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_diferimento: true,
    aliquota_diferimento_fcp: true,
    aliquota_reducao: true,
    aliquota_reducao_st: true,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: true,
  },
  "90": {
    aliquota_credito: false,
    aliquota_mva: true,
    aliquota_diferimento: true,
    aliquota_diferimento_fcp: true,
    aliquota_reducao: true,
    aliquota_reducao_st: true,
    motivo_desoneracao: true,
    motivo_desoneracao_st: true,
    beneficio_fiscal: false,
    aliquota_fcp: true,
    aliquota_fcp_st: true,
    deducao_desoneracao: true,
  },
}

const cleanObjectInfoFiscal = {
  id: "",
  descricao: "",
  icms: [
    {
      tipo_tributacao: "simples_nacional",
      cenario: "saida_dentro_estado",
      tipo_pessoa: "fisica",
      nao_contribuinte: false,
      codigo_cfop: "5102",
      situacao_tributaria: "102",
      aliquota_credito: "",
      aliquota_icms: [
        {
          estado: "",
          aliquota: "0.00",
        },
      ],
      aliquota_mva: [
        {
          estado: "",
          aliquota: "0.00",
        },
      ],
      aliquota_fcp: [
        {
          estado: "",
          aliquota: "0.00",
        },
      ],
      aliquota_fcp_st: [
        {
          estado: "",
          aliquota: "0.00",
        },
      ],
      aliquota_diferimento: "0.00",
      aliquota_diferimento_fcp: "0.00",
      aliquota_reducao: "0.00",
      aliquota_reducao_st: "0.00",
      motivo_desoneracao: "9",
      motivo_desoneracao_st: "9",
      beneficio_fiscal: [
        {
          estado: "",
          codigo: "",
        },
      ],
    },
  ],
  ipi: [
    {
      cenario: "padrao",
      tipo_pessoa: "fisica",
      situacao_tributaria: "99",
      codigo_enquadramento: "999",
      aliquota: "0.00",
    },
  ],
  pis: [
    {
      cenario: "padrao",
      tipo_pessoa: "fisica",
      situacao_tributaria: "99",
      aliquota: "0.00",
    },
  ],
  cofins: [
    {
      cenario: "padrao",
      tipo_pessoa: "fisica",
      situacao_tributaria: "99",
      aliquota: "0.00",
    },
  ],
  issqn: [
    {
      cenario: "",
      tipo_pessoa: "",
      codigo_cfop: "",
      exigibilidade: "",
      item_servico: "",
      incentivo_fiscal: "",
      aliquota: "",
    },
  ],
  ibs_cbs: [
    {
      tipo_pessoa: "fisica",
      cenario: "saida_dentro_estado",
      situacao_tributaria: "000",
      situacao_tributaria_regular: '000',
      classificacao_tributaria: "000001",
      classificacao_tributaria_regular: "000001",
      ibs_estadual: {
        aliquota_diferimento: 0,
      },
      ibs_municipal: {
        aliquota_diferimento: 0,
      },
      cbs: {
        aliquota_diferimento: 0,
      },
      credito_presumido: {
        classificacao: "3",
        aliquota_ibs: 0,
        aliquota_cbs: 0,
      }
    },
  ],
  informacoes_fisco: "",
  informacoes_complementares: "",
}
const cstPisCofins = [
  { value: "00", text: "00 - Nenhum" },
  { value: "01", text: "01 - Operação Tributável com Alíquota Básica" },
  { value: "02", text: "02 - Operação Tributável com Alíquota Diferenciada" },
  { value: "03", text: "03 - Operação Tributável com Alíquota por Unidade de Medida de Produto" },
  { value: "04", text: "04 - Operação Tributável monofásica - Revenda a Alíquota Zero" },
  { value: "05", text: "05 - Operação Tributável por Substituição Tributária" },
  { value: "06", text: "06 - Operação Tributável a Alíquota Zero" },
  { value: "07", text: "07 - Operação Isenta da Contribuição" },
  { value: "08", text: "08 - Operação sem Incidência da Contribuição" },
  { value: "09", text: "09 - Operação com Suspensão da Contribuição" },
  { value: "49", text: "49 - Outras Operações de Saída" },
  { value: "50", text: "50 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Internom" },
  { value: "51", text: "51 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno" },
  { value: "52", text: "52 - Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação" },
  { value: "53", text: "53 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno" },
  { value: "54", text: "54 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas no Mercado Interno e de Exportação" },
  { value: "55", text: "55 - Operação com Direito a Crédito - Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação" },
  { value: "56", text: "56 - Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação" },
  { value: "60", text: "60 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno" },
  { value: "61", text: "61 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno" },
  { value: "62", text: "62 - Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação" },
  { value: "63", text: "63 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno" },
  { value: "64", text: "64 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação" },
  { value: "65", text: "65 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação" },
  { value: "66", text: "66 - Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação" },
  { value: "67", text: "67 - Crédito Presumido - Outras Operações" },
  { value: "70", text: "70 - Operação de Aquisição sem Direito a Crédito" },
  { value: "71", text: "71 - Operação de Aquisição com Isenção" },
  { value: "72", text: "72 - Operação de Aquisição com Suspensão" },
  { value: "73", text: "73 - Operação de Aquisição a Alíquota Zero" },
  { value: "74", text: "74 - Operação de Aquisição sem Incidência da Contribuição" },
  { value: "75", text: "75 - Operação de Aquisição por Substituição Tributária" },
  { value: "98", text: "98 - Outras Operações de Entrada" },
  { value: "99", text: "99 - Outras Operações" },

]
export { initialStateInfoFiscal, initialStateTaxForSelectBoxes, initialStateObjectIcms, cleanObjectInfoFiscal, cstPisCofins }
